package cc.easyandroid.easycompose.component.router.stack

import cc.easyandroid.easycompose.component.Child
import cc.easyandroid.easycompose.component.ExperimentalDecomposeApi
import cc.easyandroid.easycompose.component.router.webhistory.WebNavigation
import cc.easyandroid.easycompose.component.router.webhistory.WebNavigation.HistoryItem
import cc.easyandroid.easycompose.component.router.webhistory.WebNavigationOwner
import cc.easyandroid.easycompose.component.value.Value
import cc.easyandroid.easycompose.component.value.operator.map
import kotlinx.serialization.KSerializer

@ExperimentalDecomposeApi
fun <C : Any, T : Any> childStackWebNavigation(
    navigator: StackNavigator<C>,
    stack: Value<ChildStack<C, T>>,
    serializer: KSerializer<C>,
    enableHistory: Boolean = true,
    pathMapper: (Child.Created<C, T>) -> String? = { null },
    parametersMapper: (Child.Created<C, T>) -> Map<String, String>? = { null },
    onBeforeNavigate: () -> Boolean = { true },
    childSelector: (Child.Created<C, T>) -> WebNavigationOwner? = { null },
): WebNavigation<*> =
    StackWebNavigation(
        navigator = navigator,
        stack = stack,
        serializer = serializer,
        enableHistory = enableHistory,
        pathMapper = pathMapper,
        parametersMapper = parametersMapper,
        onBeforeNavigate = onBeforeNavigate,
        childSelector = childSelector,
    )

private class StackWebNavigation<C : Any, T : Any>(
    private val navigator: StackNavigator<C>,
    stack: Value<ChildStack<C, T>>,
    override val serializer: KSerializer<C>,
    private val enableHistory: Boolean,
    private val pathMapper: (Child.Created<C, T>) -> String?,
    private val parametersMapper: (Child.Created<C, T>) -> Map<String, String>?,
    private val onBeforeNavigate: () -> Boolean,
    private val childSelector: (Child.Created<C, T>) -> WebNavigationOwner?,
) : WebNavigation<C> {

    override val history: Value<List<HistoryItem<C>>> = stack.map { it.toHistory() }

    private fun ChildStack<C, T>.toHistory(): List<HistoryItem<C>> =
        (if (enableHistory) items else items.takeLast(1)).map { child ->
            HistoryItem(
                path = pathMapper(child) ?: "",
                parameters = parametersMapper(child) ?: emptyMap(),
                key = child.configuration,
                child = childSelector(child),
            )
        }

    override fun onBeforeNavigate(): Boolean =
        onBeforeNavigate.invoke()

    override fun navigate(history: List<C>) {
        navigator.navigate { history }
    }
}
